const $ = require('jquery');
const form = require('aemps-form');

/**
 * Trim value, and eliminates internal spaces.
 */
function normalizeAuthenticationCode(value) {
	return value && value.trim().replace(' ', '');
}

function validate() {
	let errors = [];
	let username = $('[name=username]').val();
	if (!username) {
		errors.push(buildError('username', 'Campo obligatorio'));
	}

	let password = $('[name=password]').val();
	if (!password) {
		errors.push(buildError('password', 'Campo obligatorio'));
	}
	let $authCode = $('[name=authenticationCode]');
	if ($authCode.length) {
		let authenticationCode = $authCode.val();



		if (!authenticationCode) {
			errors.push(buildError('authenticationCode', 'Campo obligatorio'));
		} else {
			if (!/^[0-9]+$/.test(authenticationCode)) {
				errors.push(buildError('authenticationCode', 'Formato inválido (sólo dígitos)'));
			}
		}
	}
	return errors;
}

//[{ field: "nombre del campo", message: "mensaje de error", code: "código del mensaje" }]

function buildError(field, message) {
	return {
		field,
		message
	};
}

function showCapsLockWarning(show) {
	if (show) {
		$('#login-capsLockWarning').removeClass('invisible');
	} else {
		$('#login-capsLockWarning').addClass('invisible');
	}
}

let authenticationPreference = (function () {
	let hostParts = window.location.hostname.split('.');
	hostParts.shift();
	const domain = hostParts.join('.');
	
	let pathname = window.location.pathname;
	let [, context, ] = pathname.split('/');
	let path = '/' + context;

	/**
	 * Devuelve una cadena del tipo "expires=fechaGMT", dónde fechaGMT será una fecha
	 * en formato GMT, calculada desde la fecha actual y sumando los segundos especificados
	 * en el parámetro.
	 * @param {number} seconds
	 */
	function calculateExpires(seconds) {
		var date = new Date();
		date.setTime(date.getTime() + (seconds * 1000));
		return "Expires=" + date.toGMTString();
	}

	const ONE_YEAR_IN_SECONDS = 365 * 24 * 60 * 60;

	return {
		retrieve() {
			let cookies = (function cookies() {
				return document.cookie.split(';').reduce((a,c) => {let [k,v] = c.split('=');a[k.trim()] = v.trim(); return a;}, {});
			})();
			return cookies['aemps.security.prefs.authentication-method'];
		},
		store(method) {
			let expires = calculateExpires(ONE_YEAR_IN_SECONDS);
			document.cookie = `aemps.security.prefs.authentication-method=${method};Domain=${domain};Path=${path};${expires};Max-Age=${ONE_YEAR_IN_SECONDS};Secure;SameSite=Lax`;
		}
	};
})();

function showLoginForm() {
	$('#section-wait').removeClass('d-flex').addClass('d-none');
	$('#section-seleccion').addClass('d-none');
	$('#section-login').removeClass('d-none');
	document.getElementById('username').focus();
}
function showAuthenticationMethod() {
	$('#section-wait').removeClass('d-flex').addClass('d-none');
	$('#section-seleccion').removeClass('d-none');
	$('#section-login').addClass('d-none');
}

function parseSearch(search) {
    if (!search || search.length === 0) {
        return {};
    }
	let params = (search.startsWith('?') ? search.substring(1) : search).split('&');
    let o = {};
    if (params.length) {
        params.forEach(function (p) {
            let [key,value] = p.split('=');
            if (key.trim() !== '') {
                let parsedValue = value && value.trim();
                o[key] = parsedValue && decodeURIComponent(parsedValue);
            }
        });
    }
	return o;
}
function extractSearchParams() {
	return parseSearch(window.location.search);
}

$(function () {
	let preferedAuthenticationMethod = authenticationPreference.retrieve();
	let params = extractSearchParams();
	if (params.access) {
		preferedAuthenticationMethod = params.access;
		authenticationPreference.store(params.access);
	}

	switch(preferedAuthenticationMethod) {
		case 'verificationCode': 
			if (window.location.href.startsWith(options.urlVerificationCode)) {
				showLoginForm();
			} else {
				window.location.href = options.urlVerificationCode + '/login' + window.location.search;
			}
			break;
		case 'certificate':
			if (window.location.href.startsWith(options.urlCertificate)) {
				showLoginForm();
			} else {
				window.location.href = options.urlCertificate + '/login' + window.location.search;
			}
			break;

		default:
			showAuthenticationMethod();
			break;
	}
	
	$('#bVerificationCode').click(function () {
		authenticationPreference.store('verificationCode');
		if (window.location.href.startsWith(options.urlVerificationCode)) {
			showLoginForm();
		} else {
			window.location.href = options.urlVerificationCode + '/login';
		}
	});
	$('#bCertificate').click(function () {
		authenticationPreference.store('certificate');
		if (window.location.href.startsWith(options.urlCertificate)) {
			showLoginForm();
		} else {
			window.location.href = options.urlCertificate + '/login';
		}
	});

	$('#alternateUrl').click(function (event) {
		let method = $(this).data('method');
		authenticationPreference.store(method);
	});

	$('[name=password]').on('keydown', function (event) {
		if (event.originalEvent.getModifierState) {
			let isCapsLock = event.originalEvent.getModifierState('CapsLock');
			showCapsLockWarning(isCapsLock);
		}
	}).on('blur', function () {
		showCapsLockWarning(false);
	});

	$('#aemps-security-form-login').submit(function (event) {
		form.removeErrors(this);
		let errors = validate();
		if (errors.length > 0) {
			form.showErrors(errors);
			event.preventDefault();
			return false;
		} else {
			let $form = $(this);
			$.ajax({
				dataType: "json",
				url: 'csrf'
			}).then(function (response) {
				let token = response.token;
				let paramName = response.parameterName;
				$form.find(`input[name=${paramName}]`).val(token);
				$form.get(0).submit();
			});
			event.preventDefault();
			return false;
		}
	});
	
	$('#totp').on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
		if (/^\d*$/.test(this.value)) { // sólo dígitos
		    this.oldValue = this.value;
		    this.oldSelectionStart = this.selectionStart;
		    this.oldSelectionEnd = this.selectionEnd;
		} else if (this.hasOwnProperty("oldValue")) {
		    this.value = this.oldValue;
		    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
		} else {
		    this.value = "";
		}
    });
});


// WEBPACK FOOTER //
// ./js/aemps/login.js